const apiId = {
  // 栏目id
  navId: 1100, //导航栏目id
  
}

export default apiId



// WEBPACK FOOTER //
// ./src/api/apiId.js